import React, { forwardRef, lazy, Suspense } from 'react';

import type { MapViewProps } from './MapView';

const LazyMapView = lazy(() => import('./MapView'));

const MapView = forwardRef<unknown, MapViewProps>((props, ref) => (
  <Suspense fallback={null}>
    <LazyMapView {...props} ref={ref} />
  </Suspense>
));

MapView.displayName = 'MapView';

export default MapView;
